import { env } from "next-runtime-env";

import {
  isDeployedCloudApi,
  LOCAL_CLOUD_API_URL,
} from "@skydio/api_util/src/backends/cloud_api/requests-common";

export const ENV = env("NEXT_PUBLIC_ENV") ?? "development";
export const IS_DEV = ENV === "development";
export const IS_STAGING = ENV === "stagingv2";
export const IS_ONPREM = ENV === "onprem";
export const IS_CODER =
  typeof window !== "undefined" && window.location.hostname.endsWith(".coder.dev.skyd.io");
export const IS_VERCEL =
  typeof window !== "undefined" && window.location.hostname.endsWith(".skydio-vercel.com");

export const CLOUD_API_URL = env("NEXT_PUBLIC_BACKEND_URL") ?? LOCAL_CLOUD_API_URL;
export const CLOUD_API_WS_URL = CLOUD_API_URL.replace("http", "ws");
export const CLOUD_API_DEPLOYED = isDeployedCloudApi(CLOUD_API_URL);

export const DISABLE_GEOCODING = env("NEXT_PUBLIC_DISABLE_GEOCODING") == "true";

export const ROOT_DOMAIN = env("NEXT_PUBLIC_ROOT_DOMAIN");
